import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { Dayjs } from 'dayjs';
import type { MutationsObject } from '@kp/js-model';
import dayjs from 'dayjs';

export class ImportStatus extends BaseModel {
    // properties
    id: number | null = null;
    kanton_id: number | null = null;
    jahr: number | null = null;
    import_gwr_daten_start: Dayjs | null = null;
    import_gwr_daten_success: Dayjs | null = null;
    import_gwr_daten_error: Dayjs | null = null;
    import_gwr_daten_error_msg: string | null = null;
    import_angrenzende_gebaeude_start: Dayjs | null = null;
    import_angrenzende_gebaeude_success: Dayjs | null = null;
    import_angrenzende_gebaeude_error: Dayjs | null = null;
    import_angrenzende_gebaeude_error_msg: string | null = null;
    import_grossverbraucher_start: Dayjs | null = null;
    import_grossverbraucher_success: Dayjs | null = null;
    import_grossverbraucher_error: Dayjs | null = null;
    import_grossverbraucher_error_msg: string | null = null;
    import_eingespeiste_energie_start: Dayjs | null = null;
    import_eingespeiste_energie_success: Dayjs | null = null;
    import_eingespeiste_energie_error: Dayjs | null = null;
    import_eingespeiste_energie_error_msg: string | null = null;
    import_produktionseinheiten_start: Dayjs | null = null;
    import_produktionseinheiten_success: Dayjs | null = null;
    import_produktionseinheiten_error: Dayjs | null = null;
    import_produktionseinheiten_error_msg: string | null = null;
    import_solarstromanlagen_start: Dayjs | null = null;
    import_solarstromanlagen_success: Dayjs | null = null;
    import_solarstromanlagen_error: Dayjs | null = null;
    import_solarstromanlagen_error_msg: string | null = null;
    calc_gebaeude_liste_start: Dayjs | null = null;
    calc_gebaeude_liste_success: Dayjs | null = null;
    calc_gebaeude_liste_error: Dayjs | null = null;
    calc_gebaeude_liste_error_msg: string | null = null;
    calc_energieverbrauch_start: Dayjs | null = null;
    calc_energieverbrauch_success: Dayjs | null = null;
    calc_energieverbrauch_error: Dayjs | null = null;
    calc_energieverbrauch_error_msg: string | null = null;
    calc_liste_stromerzeugungsanlagen_start: Dayjs | null = null;
    calc_liste_stromerzeugungsanlagen_success: Dayjs | null = null;
    calc_liste_stromerzeugungsanlagen_error: Dayjs | null = null;
    calc_liste_stromerzeugungsanlagen_error_msg: string | null = null;

    public mutations(): MutationsObject {
        return {
            import_gwr_daten_start: (val) => val ? dayjs(val) : null,
            import_gwr_daten_success: (val) => val ? dayjs(val) : null,
            import_gwr_daten_error: (val) => val ? dayjs(val) : null,
            import_angrenzende_gebaeude_start: (val) => val ? dayjs(val) : null,
            import_angrenzende_gebaeude_success: (val) => val ? dayjs(val) : null,
            import_angrenzende_gebaeude_error: (val) => val ? dayjs(val) : null,
            import_grossverbraucher_start: (val) => val ? dayjs(val) : null,
            import_grossverbraucher_success: (val) => val ? dayjs(val) : null,
            import_grossverbraucher_error: (val) => val ? dayjs(val) : null,
            import_eingespeiste_energie_start: (val) => val ? dayjs(val) : null,
            import_eingespeiste_energie_success: (val) => val ? dayjs(val) : null,
            import_eingespeiste_energie_error: (val) => val ? dayjs(val) : null,
            import_produktionseinheiten_start: (val) => val ? dayjs(val) : null,
            import_produktionseinheiten_success: (val) => val ? dayjs(val) : null,
            import_produktionseinheiten_error: (val) => val ? dayjs(val) : null,
            import_solarstromanlagen_start: (val) => val ? dayjs(val) : null,
            import_solarstromanlagen_success: (val) => val ? dayjs(val) : null,
            import_solarstromanlagen_error: (val) => val ? dayjs(val) : null,
            calc_gebaeude_liste_start: (val) => val ? dayjs(val) : null,
            calc_gebaeude_liste_success: (val) => val ? dayjs(val) : null,
            calc_gebaeude_liste_error: (val) => val ? dayjs(val) : null,
            calc_energieverbrauch_start: (val) => val ? dayjs(val) : null,
            calc_energieverbrauch_success: (val) => val ? dayjs(val) : null,
            calc_energieverbrauch_error: (val) => val ? dayjs(val) : null,
            calc_liste_stromerzeugungsanlagen_start: (val) => val ? dayjs(val) : null,
            calc_liste_stromerzeugungsanlagen_success: (val) => val ? dayjs(val) : null,
            calc_liste_stromerzeugungsanlagen_error: (val) => val ? dayjs(val) : null,
        };
    }

    getClassName(): string {
        return 'ImportStatus';
    }
}

export class ImportStatusCollection extends BaseCollection<ImportStatus> {
    protected modelCls = ImportStatus;

    public getModelClassName(): string {
        return 'ImportStatus';
    }
}
